import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, InputAdornment, MenuItem, Typography } from "@mui/material";
import { GridCsvExportMenuItem, GridToolbarContainer, GridToolbarExportContainer, } from "@mui/x-data-grid";
import { DateRangePicker } from "@mui/x-date-pickers-pro";
import { clientConfigFn } from "clientConfig";
import DateRangeIcon from "@mui/icons-material/DateRange";
import { ExportAccountTransactionsFormat } from "generated/generated-models";
export function DesktopTransactionToolbar({ handleMenuItemClick, handleDateChange, dateRangeValue, }) {
    if (!clientConfigFn().allowTransactionExport) {
        return null;
    }
    return (_jsxs(GridToolbarContainer, { sx: { justifyContent: "space-between" }, children: [_jsx(GridCustomExportButton, { handleMenuItemClick: handleMenuItemClick }), _jsx(GridDateRangePicker, { handleDateChange: handleDateChange, dateRangeValue: dateRangeValue })] }));
}
function GridDateRangePicker({ handleDateChange, dateRangeValue, }) {
    return (_jsxs(Box, { display: "flex", alignItems: "center", children: [_jsx(Typography, { padding: 1, textTransform: "uppercase", color: "rgba(51, 51, 51, 0.60)", variant: "caption", children: "Filter By:" }), _jsx(DateRangePicker, { localeText: { start: "Start Date", end: "End Date" }, sx: { width: 450 }, slotProps: {
                    textField: {
                        size: "small",
                        InputLabelProps: { shrink: true },
                        InputProps: {
                            endAdornment: (_jsx(InputAdornment, { position: "end", children: _jsx(DateRangeIcon, {}) })),
                        },
                    },
                    actionBar: {
                        actions: ["clear"],
                    },
                }, value: dateRangeValue, onAccept: (data) => handleDateChange(data) })] }));
}
function GridCustomExportButton({ handleMenuItemClick, }) {
    return (_jsxs(GridToolbarExportContainer, { children: [_jsx(GridCsvExportMenuItem, {}), _jsx(GridOfxExportMenuItem, { handleMenuItemClick: handleMenuItemClick }), _jsx(GridQifExportMenuItem, { handleMenuItemClick: handleMenuItemClick })] }));
}
function GridOfxExportMenuItem(props) {
    const { hideMenu } = props;
    return (_jsx(_Fragment, { children: _jsx(MenuItem, { onClick: () => {
                props.handleMenuItemClick(ExportAccountTransactionsFormat.Ofx);
                hideMenu?.();
            }, children: "Download as OFX" }) }));
}
function GridQifExportMenuItem(props) {
    const { hideMenu } = props;
    return (_jsx(_Fragment, { children: _jsx(MenuItem, { onClick: () => {
                props.handleMenuItemClick(ExportAccountTransactionsFormat.Qif);
                hideMenu?.();
            }, children: "Download as QIF" }) }));
}
